// eslint-disable-next-line
export const SIDEMENU_OPEN = 'SIDEMENU_OPEN';
